module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/ant.b5d805b7.png";